import { createFileRoute } from "@tanstack/react-router";
import FederalEmployeeTms from "@/pages/FederalEmployeeTms";
export const Route = createFileRoute("/federal-employee-tms")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Federal Employee TMS | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "TMS therapy for federal employees with depression. Learn about standard TMS, SAINT TMS, and FEHB insurance coverage in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Federal Employee TMS | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "TMS therapy for federal employees with depression. Learn about standard TMS, SAINT TMS, and FEHB insurance coverage in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/federal-employee-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/federal-employee-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <FederalEmployeeTms />;
}
